import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, Clipboard, Image, SectionList,
	Platform, Dimensions, I18nManager, FlatList, AsyncStorage, TextInput } from "react-native";
	
import * as firebase from "firebase";
import * as Font from 'expo-font';
import { CheckBox } from 'react-native-elements'
import { Ionicons, FontAwesome } from "@expo/vector-icons";
import { color } from "../config/color"
import store from "../config/config.json"

import { ScrollView } from "react-native-gesture-handler";
import Main from "../widgets/Main";

import { StylesProvider, ThemeProvider, jssPreset } from "@material-ui/styles";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { create } from "jss";
import rtl from "jss-rtl";

import { TextField } from '@material-ui/core';
import i18n from 'i18n-js';
import MainComponent from "../utilities/MainComponent";
import Slideshow from '../widgets/Slideshow';
import AppContext from "../utilities/AppContext"
import * as moment from 'moment';

export default class DetailsScreen extends MainComponent {	
	
	jss = create({ plugins: [...jssPreset().plugins, rtl()] });
 	theme = createMuiTheme({
		palette: {
		  primary: {
			main: store.primaryColor,
		  }
		}
	});

	static path = "details"
	state = {
		dimensions: {
			height: 15
		},
		addonsData : [],
		itemId : "",
		images: [],
		hovered: [],
		addonsList: [],
		imagesList: [],
		store : {currency: ""},
		instructions: "",
		counter: 1,
		showFullMode 	: true,
		item : {},
		totalPrice: 0
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
				
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}

		if(window.location.href.includes("search"))
			this.state.title = "Search"
		if(window.location.href.includes("menu"))
			this.state.title = "Menu"
		
		this.state.itemId = this.props.navigation.state.params.item
		this.state.counter = 1
		this.state.imageIndex = 0;	
		this.state.addedStock = 0;				
		this.getDetails()
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})		
		
		if(this.context === undefined || this.context.itemData == undefined)
		{
			this.loadData('data/' + store.storeId)
		}
		else
		{
			this.state.offerData = this.context.offerData
			this.state.item 	  = this.context.itemData
			let images = [];
			if (this.context.itemData.images) {
				this.context.itemData.images.map ((imageUrl) => {
					images.push({
						url : imageUrl
					})
				})
			}
			this.state.stockLimit = -1
			if(this.state.item.allowStock)
				this.state.stockLimit = this.state.item.stock

			this.state.imagesList = images
			this.loadData('data/' + store.storeId + "/" + this.state.item.categoryId + "/items/" + this.state.item.key)
		}
	}

	loadData(path)
	{
		var that = this;
		firebase.database().ref(path).once("value", function(snapshot) {
			if(snapshot.exists())
			{			
				snapshot.forEach(function(childSnapshot) {								
					
					var childData = childSnapshot.val();
					var itemsList = childData.items
					if (itemsList != undefined)
					{
						Object.keys(itemsList).forEach(key => {
							let value = itemsList[key];
							if(key == that.state.itemId)
							{
								that.context.itemData = value																			
							}
						});
						
					}						
				});

				if(that.context.itemData == undefined)
				{
					that.props.navigation.navigate("menu")
					return
				}

				that.state.item 	  = that.context.itemData

				that.state.stockLimit = -1
				if(that.state.item.allowStock)
					that.state.stockLimit = that.state.item.stock
	
				that.calculateTotalPrice()
				var imagesList = []
				if(that.context.itemData.images != undefined)
				{
					that.context.itemData.images.map( obj => {
						if(!obj.includes(".mp4"))
						{
							imagesList.push({
								url : obj
							})
						}
						else
						{
							imagesList.push({ url: obj, type: 'video'})
						}			
					})
				}

				that.state.imagesList = imagesList
				that.setState({isLoading: false})
			}
			else
			{
				that.props.navigation.goBack(null)
			}	

		}.bind(this), function(error) { 
			console.log(error)
		});
	}

	getDetails = async () => 
	{
		await Font.loadAsync(color.appFonts);
		try {

			var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
			this.setState({store: value})     
			       
        } catch (error) {
            console.log(error)
		}
		

		try{			

			value = await AsyncStorage.getItem(store.key)
			if (value == undefined)
				value = []
			else
			{
				try{
					value = JSON.parse(value)
				} catch (error) {
					value = []
				}
			}			

			var addedStock = 0;
			if(value.length > 0)
			{
				value.forEach( data =>{					
					if(data.key == this.state.itemId){
						addedStock += data.counter
					}
				})			
			}
			this.setState({addedStock: addedStock, orderData : value})     

		} catch (error) {
			console.log(error)
			this.setState({isLoading: false})
		}

		this.calculateTotalPrice()
	}

	backBtnPressed(){
		this.props.navigation.goBack(null)
	}

	reduceCounter(){
		var counter = +this.state.counter - 1
		if (counter < 1)
			counter = 1

		this.state.counter = counter
		this.setState({counter: counter})
		this.calculateTotalPrice()
	}

	addCounter(){

		var itemsList = []
		var shouldAllow = true

		let counter = +this.state.counter + 1
		var stockCounter = 0
		
		var allowStock =  this.state.item.allowStock == undefined ? false : this.state.item.allowStock
		if (allowStock)
		{
			let stock = this.state.item.stock == undefined ? 0 : this.state.item.stock				
			this.state.orderData.forEach(data => 
			{
				if(data.key == this.state.item.key)
				{
					stockCounter += data.counter
					if(data.counter > 0)
						itemsList.push(data)
				}
			})

			stockCounter += +this.state.counter
			if(stockCounter >= stock)
				shouldAllow = false

			if(shouldAllow)
			{
				this.state.counter = counter
				this.setState({counter: counter})
				this.calculateTotalPrice()		
			}
		}
		else
		{
			this.state.counter = counter
			this.setState({counter: counter})
			this.calculateTotalPrice()		
		}
	}

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */
	calculateTotalPrice()
	{
		if(this.state.item == undefined)
			return

		var item = this.state.item
		var totalPrice = item.price
		var addons = item.addons
		var mAddonsList = []

		if(addons == undefined){
			addons = []
		}

		var mData = []
		Object.keys(addons).forEach(key => {
			let addon = addons[key];
			if(addon.modifiers == undefined)
				addon.modifiers = []

			if(addon.modifiers.length > 0 && addon.status)
			{
				if(addon.showColors){
					addon.data = [{showColors: true, data: addon.modifiers}]
				}else
					addon.data = addon.modifiers;
				mAddonsList.push(addon)
			}
		});	

		var finalAddonsList = []
		mAddonsList.forEach(mAddon => 
		{
			finalAddonsList.push(mAddon)
			mAddon.modifiers?.forEach(modifier =>
			{
				if(modifier.checked)
				{
					if(modifier.modifierTags != undefined && modifier.modifierTags.length > 0)
					{
						totalPrice +=  parseFloat(modifier.price)
						modifier.modifierTags.forEach(choice => 
						{
							if(choice.showColors)
							{
								choice.data = [{showColors: true, data: choice.modifiers}]
							}else
								choice.data = choice.modifiers;
							choice.status = true

							choice.modifiers?.map(mModifier => {
								if(mModifier.checked)
									totalPrice +=  parseFloat(mModifier.price)
							})

							finalAddonsList.push(choice)
						})
					}
					else
					{
						totalPrice +=  parseFloat(modifier.price)
					}
				}
			})
		})	
				
		totalPrice = totalPrice * this.state.counter
		this.state.totalPrice = totalPrice
		this.setState({totalPrice: totalPrice, addonsList: finalAddonsList, addonsData: mData})
	}

	changeCheckboxValue(item, index)
	{	
		this.state.addonsList.forEach((addon, addonIndex) => 
		{
			if(addon.key == item.addonKey)
			{
				if(!item.checked)
				{
					var selectedCount = 0;
					addon.modifiers.forEach((modifier, modIndex) => 
					{		
						if(modifier.checked)
							selectedCount = selectedCount + 1;
					})

					if(selectedCount >= addon.minAllowed && selectedCount < addon.maxAllowed)
					{
					}
					else
					{
						addon.modifiers.every((modifier, modIndex) => 
						{		
							if(modifier.checked)
							{
								this.state.addonsList[addonIndex].modifiers[modIndex].checked = !this.state.addonsList[addonIndex].modifiers[modIndex].checked
								return false
							}else
								return true
						})
					}
				}

				this.state.addonsList[addonIndex].modifiers[index].checked = !this.state.addonsList[addonIndex].modifiers[index].checked
				this.calculateTotalPrice()
			}
		});	
	}

	handleChange = name => event => {
		this.setState({[name]: event.target.value});
	};

	onLayout = event => {
		let {width, height} = event.nativeEvent.layout
		this.setState({dimensions: {width, height}})
	}

	getSelectedAddons()
	{
		var addons = []
		var shouldAllow = true
			if(this.state.item.addons == undefined){
				addons = []
			}else{
				this.state.addonsList.forEach(addon => {
					var modifiers = []					
					addon.modifiers.map(modifier => {
						if(modifier.checked)
						{
							if(modifier.color != undefined)
								modifiers.push({name: modifier.name, price: modifier.price, color: modifier.color, key: modifier.key})
							else
								modifiers.push({name: modifier.name, price: modifier.price, key: modifier.key})
						}
					})

					if(addon.required && (modifiers.length < addon.minAllowed || modifiers.length > addon.maxAllowed)){
						shouldAllow = false
					}
					else{

						var mAddon = {name:addon.name, key: addon.key, modifiers: modifiers, details: addon.details}
						if(addon.baseAddonKey != undefined)
							mAddon.baseAddonKey = addon.baseAddonKey
						addons.push(mAddon)
					}
				});	
			}

		if (shouldAllow)	
			return addons
		else return undefined
	}

	checkout = async() => {

		try {
			
			var addons = this.getSelectedAddons()
			if(addons == undefined)
			{
				alert("Please select Addons per requirement")
				return
			}

			var that = this
			AsyncStorage.getItem(store.key)
				.then((value) => {

					if (value == undefined || value == "undefined" || value == "")
						value = []
					else
					{
						try{
							value = JSON.parse(value)
						} catch (error) {
							value = []
						}
					}

					// Calculating price and taxes					
					let mItem = {
								mainItem     : this.state.item,
								categoryId   : this.state.item.categoryId,
								counter 	 : this.state.counter,
								key 		 : that.state.item.key,
								productId	 : that.state.item.productId, 
								name		 : that.state.item.name, 
								price		 : that.state.item.price,
								images	 	 : that.state.item.images == undefined ? [] : that.state.item.images,
								details 	 : that.state.item.details,
								instructions : that.state.instructions,
								tax			 : that.state.item.tax,			
								disableTax   : that.state.item.disableTax == undefined ? false : that.state.item.disableTax,								
								addons : addons
							}

					if(this.state.offerData != undefined)
					{
						var offerData = {
							amount: that.state.offerData.amount,
							title : that.state.offerData.title,
							key : that.state.offerData.key,
							promotionType : that.state.offerData.promotionType,
							type : that.state.offerData.type
						}
						mItem.offerData = offerData
					}

					that.callPixelEvent("Add To Cart", mItem)
					value.push(mItem)
					value = JSON.stringify(value)
					
					AsyncStorage.setItem(store.key, value).then((value) => 
					{
						var onUpdate = that.context.onUpdate
						that.props.navigation.goBack(null)
						if(onUpdate != undefined)
							onUpdate();		
					});
			})			
		} catch (error) {
			console.log(error)
		}
	}

	async openShare(){
		let link = store.webUrl + "/share/?" + this.state.item.itemCode
		await Clipboard.setString(link);

		var mUpdates = {
			key: this.state.item.key,
			name: this.state.item.name,
			price: this.state.item.price,
			share: firebase.database.ServerValue.increment(1),
			views    : firebase.database.ServerValue.increment(0)
		};

		firebase.database().ref('statistics/stores/sharedItems/' + store.storeId + '/monthly/shift_' + moment(new Date()).format('MMYYYY') + "/" + this.state.item.key).update(mUpdates)
   		alert('Link has been copied to the Clipboard!');
	}

	renderListItem = ({ item, index, section }) => 
	{		
		var shouldDisable = false
		var name = item.name
        var details = item.details;

        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.nameSec
            details = item.detailsSec
        }

        if(name == undefined || name == "")
            name = item.name
        if(details == undefined || details == "")
			details = item.details

		var color = "black"
		if(item.color != undefined && item.color != "#000" && item.color != "#000000")
			color = item.color

		var showColors = false;
		if(section.showColors != undefined && section.showColors)
			showColors = true

		var stockText = ""
		if(item.allowStock != undefined && item.stock != undefined && item.allowStock == true)
		{
			if(item.stock < 4 && item.stock > 0)
				stockText = `(${item.stock} left)`
			
			if(item.stock == 0)
				shouldDisable = true
		}

		if(!showColors)
		{
			if(shouldDisable)
				details = i18n.t("outOfStock")

			return (				
				<View  style={{marginLeft: 15, marginRight: 15, height: 55, backgroundColor: "white"}}>
					<View style={{ flexDirection: "row", height: 55,  alignContent: "center", alignItems:"center", opacity : shouldDisable ? 0.3 : 1}}>
								<CheckBox 		
									disabled={shouldDisable}
									checkedIcon='dot-circle-o'
									uncheckedIcon='circle-o'
									checked={item.checked}
									containerStyle={{padding: 0, margin: 0}}
									checkedColor={this.state.store.primaryColor}
									uncheckedColor={this.state.hovered[item.addonKey + "_" + item.name + "_" + index] ? this.state.store.primaryColor : color.lightGray}
									onMouseEnter={() => 
										{
											this.state.hovered[item.addonKey + "_" + item.name + "_" + index] = true
											this.setState({hovered: this.state.hovered})
										}
									}
									onMouseLeave={() => {
										this.state.hovered[item.addonKey + "_" + item.name + "_" + index] = false
										this.setState({hovered: this.state.hovered})
									}}
									onPress={() => 
										this.changeCheckboxValue(item, index)
									}
						/>
							<View style={{flexDirection: 'row', alignContent: "center", alignItems: "center", justifyContent: "center", flex: 1}}>
								<View  style={{flex:1, justifyContent: "center"}}>
									<Text style={{textAlign: "left", fontFamily: 'main-bold', color: color  , fontSize: 16 }}>{`${name} ${stockText}`}</Text>
									{ details != undefined && details != "" && (<Text style={{textAlign: "left", fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12, marginTop:2 }}>{details} </Text>)} 
								</View>	

								{ I18nManager.isRTL && (
									<Text style={{ fontFamily: 'main-regular',marginLeft: "auto", color: color.detailsColor, fontSize: 16 }}>+ {item.price.toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>
								)}
								{ !I18nManager.isRTL && (
									<Text style={{ fontFamily: 'main-regular',marginLeft: "auto", color: color.detailsColor, fontSize: 16 }}>+ {i18n.t('currency.' + this.state.store.currency.toLowerCase())} {item.price.toFixed(3)} </Text>
								)}

							</View>											
					</View>
					<View style={{height: 1, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
				</View>
			);
		}
		else
		{
			return (				
				<View  style={{marginTop: 15, marginLeft: 15, marginRight: 15, height: 55, backgroundColor: "white", flex: 1}}>
					<FlatList
							extraData={this.state.addonsList}
							showsHorizontalScrollIndicator={false}
							data={section.data[0].data}
							horizontal={true}
							renderItem={this.renderColorItem}
						/>
					<View style={{height: 1, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
				</View>
			);
		}
	}

	renderColorItem = ({item, index}) => {
		return (				
			<TouchableOpacity style={{marginLeft: 15, height: 36, width: 36, justifyContent: "center", alignItems: "center"}}
								onPress={() => {this.changeCheckboxValue(item, index)}}>
				<View  style={{borderRadius: 23, height: 34, width: 34, backgroundColor:item.color, justifyContent: "center", alignItems: "center"}}>
					{( item.checked &&
						<Image source={require('../assets/check.png')} style={{marginTop: 5, width: 16, height: 16, overflow:"hidden"}}/>
					)}
				</View>
			</TouchableOpacity>			
		);
	}

	renderHeader = ({ section }) => {
		
		var width = this.state.width
		if(this.state.showFullMode){
			width = this.state.width * .33
		}
		
		let item = section
		var requiredColor = "#929292"
		if(item.required){
			
			var totalChecked = 0
			item.data.map(modifier => {
				if(modifier.checked){
					totalChecked += 1
				}
			})

			if(totalChecked >= item.minAllowed){
				requiredColor = this.state.store.primaryColor
			}
		}	

		var minText = 0;
		if(item.minAllowed == undefined)
			item.minAllowed = 0;
		if(item.maxAllowed == undefined)
			item.maxAllowed = 0;
		if(item.maxAllowed == item.minAllowed)
		{
			//Chose one of the choices:
			minText = i18n.t("selectmany").replace("x", "1")
		}
		else if(item.maxAllowed > item.minAllowed)
		{
			//Chose 3 as minimum up to 46 Maximum.
			minText = i18n.t("selectmiddle").replace("x", item.minAllowed)
			minText = minText.replace("xx", item.maxAllowed)
		}
		else if(item.maxAllowed > 0 && item.minAllowed == 0)
		{
			//Chose $$ of the choices.
			minText = i18n.t("selectmany").replace("x", item.maxAllowed)
		}

		var name = item.name
        if(i18n.locale != this.state.store.defaultLanguage){
            name    = item.nameSec
        }

        if(name == undefined || name == "")
            name = item.name

		return (
			<View style={{height: 73}}>
				
				<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
				<View style={{flexDirection: "row", height: 65, alignItems: "center"}}>
					<View>
						<Text style={{textAlign: "left",  fontFamily: 'main-bold',marginLeft: 15, color: 'black', fontSize: 16 }}>{name}</Text>
						<Text style={{textAlign: "left",  fontFamily: 'main-regular',marginLeft: 15, color: color.detailsColor , fontSize: 12, marginTop:2 }}>{minText}</Text>

					</View>
						{ item.required && (	
							<Text style={{backgroundColor: requiredColor, paddingLeft: 10, paddingRight: 10, borderRadius: 12, paddingTop:3, 
							height: 24, fontFamily: 'main-regular', marginLeft:"auto", marginRight: 15, color: "white", 
							fontSize: 13, textAlign: "center" }}>{i18n.t("required")}</Text>
						)}
				</View>			

			</View>
		);
	}
	/*
	_renderItem = ({ item }) => {
		var width = this.state.width
		if(this.state.showFullMode){
			width = this.state.width * .33
		}
		
		return (
			<View key={item} style={{width: width, height: 305}}>
				<ImageBackground source={item} style={{width: "100%", height: 305, overflow: "hidden"}}/>							
			</View>
		);
	};
	*/
	renderDetails(width){

		var name = this.state.item.name
        var details = this.state.item.details;

        if(i18n.locale != this.state.store.defaultLanguage){
            name    = this.state.item.nameSec
            details = this.state.item.detailsSec
        }

        if(name == undefined || name == "")
            name = this.state.item.name
        if(details == undefined || details == "")
			details = this.state.item.details
			
		var icoName = "ios-arrow-forward"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-back"

		if(this.state.item.price == undefined){
			this.state.item.price = 0
		}

		var rightOpacity = 1;
		var leftOpacity = 1;
		if(this.state.imageIndex >= this.state.imagesList.counter)
			leftOpacity = .5
		
		if(this.state.imageIndex <= 0)
			rightOpacity = .5

		var sectionHeight = this.state.addonsList.length * 73
		this.state.addonsList.forEach(item => {
			sectionHeight = sectionHeight + (item.data.length * 55)
		})

		sectionHeight = sectionHeight + 15

		var shouldDisable = false
		var opacity = 1
		var erroMsg = i18n.t("tempClosed")
		if(this.state.store.status == false)
		{
			shouldDisable = true
			opacity = .5
		}
		else if(this.state.item.allowStock && this.state.addedStock >= this.state.item.stock)
		{
			erroMsg = i18n.t("outOfStock")
			shouldDisable = true
			opacity = .5
		}

		var price = this.state.totalPrice
		if (this.state.offerData != undefined)
		{
			if (this.state.offerData.type == 10) // Fixed price
				price = price - +this.state.offerData.amount

			if (this.state.offerData.type == 11) // percentage
				price = price -  (+this.state.offerData.amount * price/100)
			
			if(price < 0)
				price = 0
		}

		if(price == undefined)
			price = 0

		var mTotalPrice = ""
		if(price != undefined)
		{
			price = price.toFixed(3)
			if(I18nManager.isRTL)
			{
				 mTotalPrice = " (" + this.state.totalPrice.toFixed(3) + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase()) + ") "
				 price = price + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			}
			else
			{
				mTotalPrice = " (" + i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " +this.state.totalPrice.toFixed(3) + ") "
				price = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + price
			}
		}

		return (
			
			<View style={styles.container}>
				
				<ScrollView
					nestedScrollEnabled={false}
					style={{marginTop: 38}}
					showsHorizontalScrollIndicator={false}
				>

					<View style={{backgroundColor : 'white', height: 300, width: width, alignContent: "center", direction: "ltr"}}>
						<Slideshow 
						width={width}
						height={300}
						dataSource={this.state.imagesList}/>
					</View>

					<View style={{marginLeft: 15, marginTop: 15, marginRight: 15, marginBottom: 15, height: this.state.dimensions.height + 15}}>
							
							<View style={{position: "absolute", marginRight: 55}}>
								<Text style={{textAlign: "left", fontFamily: 'main-bold', color: "black", fontSize: 18 }}>{name} </Text>
								<Text style={{textAlign: "left", fontFamily: 'main-regular', color: color.detailsColor, fontSize: 14 }} onLayout={this.onLayout}>{details} </Text>
							</View>						

							<TouchableOpacity style={{marginLeft: "auto", height:38, width: 40, justifyContent: "center", alignItems: "center"}}
								onPress={() => {this.openShare()}} >
								<Image source={require('../assets/share.png')} style={{marginLeft: 15, width: 24, height: 24, overflow:"hidden"}}/>
							</TouchableOpacity>	

					</View>

					<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>

					<View style={{marginLeft: 15, minHeight: 50, marginRight: 15, justifyContent: "center"}}>
							<View style={{height: 50, flexDirection: "row", justifyContent: "center", alignContent: "center", alignItems:"center"}}>
								<Text style={{ fontFamily: 'main-bold'	 ,color: "black"  		   , fontSize: 15, textAlign: "center" }}>{i18n.t("price")}</Text>
									{ I18nManager.isRTL && (
										<Text style={{ fontFamily: 'main-regular',color: color.detailsColor, fontSize: 15, textAlign: "center", marginLeft:"auto", }}>{this.state.item.price.toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>
									)}
									{ !I18nManager.isRTL && (
										<Text style={{ fontFamily: 'main-regular',color: color.detailsColor, fontSize: 15, textAlign: "center", marginLeft:"auto", }}>{i18n.t('currency.' + this.state.store.currency.toLowerCase())} {this.state.item.price.toFixed(3)} </Text>
									)}
							</View>						

							{ this.state.item.preparationTime != undefined && ( <Text style={{marginTop: -5, marginBottom: 10, fontFamily: 'main-regular', color: "#A07927" , fontSize: 13, }}>Preparation time {this.state.item.preparationTime}</Text>)}
					</View>
					
					{this.state.addonsList.length > 0 && (												
						
						<SectionList
							contentOffset={{x: 0, y: 0}}
							showsHorizontalScrollIndicator={false}
							showsVerticalScrollIndicator={false}
							style={{height : sectionHeight}}
							sections={this.state.addonsList}
							renderItem={this.renderListItem}
							renderSectionHeader={this.renderHeader}
						/>
																	
					)}

					{(this.state.item.allowInstructions &&
						<View style={{ height: 90}}>
							<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
							<View style={{ marginBottom: 15, marginLeft:15, marginRight: 15, marginTop:5}}>

							<StylesProvider jss={this.jss}>
									<ThemeProvider theme={this.theme}>							
											<TextField 
												style={{marginTop:10, textAlign:"left"}}								
												id="standard-basic" 
												label={i18n.t("instructions")} 
												value={this.state.instructions}
												onChange={this.handleChange('instructions')}
												/>
									</ThemeProvider>
								</StylesProvider>
							
							</View>							
						</View>
					)}

					<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
						
							{ I18nManager.isRTL && (
								<View style={{marginLeft: 5, marginTop: 15, flexDirection: "row", alignContent: "center", alignItems: "center", justifyContent: "center"}}>
																		
									<TouchableOpacity style={{height:35}}
											onPress={() => { this.addCounter() }}
									>
										<Ionicons style={{marginRight: 15}} name="ios-add-circle-outline" size={24} color={this.state.store.primaryColor} />														
									</TouchableOpacity>
									
									<TextInput 	
										multiline={false}
										keyboardType="number-pad"
										value={this.state.counter}
										onChangeText={text => {
											text = text.replace(/\D/,'')
											if(text.length > 0 && text.length < 4)
											{
												this.state.counter = +text
											 	this.setState({counter: +text})
												this.calculateTotalPrice()
											}
										}}
										style={{
											borderRadius: 5,
											backgroundColor: color.bigSeparator,
											width: 55, marginTop: -12, fontFamily: 'main-regular', 
											fontWeight: "bold", color: "black", height: 35, 
											textAlign: "center", fontSize: 18 
										}}>
									</TextInput>

									<TouchableOpacity style={{height:35, opacity: this.state.counter > 1 ? 1: 0.5}} disabled={this.state.counter > 1 ? false: true} 
										onPress={() => { this.reduceCounter() }}
									>
										<Ionicons style={{marginLeft: 15}} name="ios-remove-circle-outline" size={24} color={this.state.store.primaryColor} />														
									</TouchableOpacity>
								</View>	
							)}
							{ !I18nManager.isRTL && (

								<View style={{marginLeft: 5, marginTop: 15, flexDirection: "row", alignContent: "center", alignItems: "center", justifyContent: "center"}}>
									<TouchableOpacity style={{height:35, opacity: this.state.counter > 1 ? 1: 0.5}} disabled={this.state.counter > 1 ? false: true} 
										onPress={() => { this.reduceCounter() }}
									>
										<Ionicons style={{marginRight: 15}} name="ios-remove-circle-outline" size={24} color={this.state.store.primaryColor} />														
									</TouchableOpacity>

									<TextInput 	
										keyboardType="number-pad"
										multiline={false}
										value={this.state.counter.toString()}
										onChangeText={text => {
											text = text.replace(/\D/,'')
											if(text.length > 0 && text.length < 4)
											{
												this.state.counter = +text
											 	this.setState({counter: +text})
												this.calculateTotalPrice()
											}
										}}
										style={{
											borderRadius: 5,
											backgroundColor: color.bigSeparator,
											width: 55, marginTop: -12, fontFamily: 'main-regular', 
											fontWeight: "bold", color: "black", height: 35, 
											textAlign: "center", fontSize: 18 
										}}>
									</TextInput>

									<TouchableOpacity style={{height:35}}
											onPress={() => { this.addCounter() }}
									>
										<Ionicons style={{marginLeft: 15}} name="ios-add-circle-outline" size={24} color={this.state.store.primaryColor} />														

									</TouchableOpacity>

								</View>	
							)}
						
					<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>

					<View style={{height: 35, backgroundColor:"white", justifyContent: "center"}}/>

				</ScrollView>
				
				<View style={{height: 64, marginTop: "auto", backgroundColor:"white", justifyContent: "center"}}>
					{!shouldDisable && (
					<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 10, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.checkout() }}
								>
					<View style={{justifyContent: "center", alignItems: "center", flex:1, flexDirection: "row", borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>

							<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}>{i18n.t("addToOrder") + " - "}</Text> 
							{this.state.offerData &&(
							<Text style={{ fontFamily: 'main-regular',color:'#FFF', textDecorationLine: 'line-through', textDecorationStyle: 'solid', fontSize:16}}>{mTotalPrice}</Text> 
							)}
							<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}>{price}</Text> 								
					</View>

					</TouchableOpacity>
					)}

					{shouldDisable && (
					<TouchableOpacity disabled={shouldDisable} style={{marginLeft: 10, opacity: opacity, marginRight: 10, marginBottom: 10, marginTop: "auto", height:48, justifyContent: "center"}}
										
								>
					<View style={{justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
							{ I18nManager.isRTL && (
								<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}>{erroMsg}</Text> 
							)}
							{ !I18nManager.isRTL && (
								<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}> {erroMsg}</Text> 
							)}
					</View>

					</TouchableOpacity>
					)}


				</View>

			</View>
		)
	}

	render() {

		if(I18nManager.isRTL){
			this.theme = createMuiTheme({
				direction : "rtl",
				palette: {
				  primary: {
					main: store.primaryColor,
				  },
				}, 
			  });
		}else{
			this.theme = createMuiTheme({
				palette: {
				  primary: {
					main: store.primaryColor,
				  },
				}, 
			  });
		}


		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		var that = this
		return (
			
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>

				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

	                        {that.renderDetails(this.state.width * .33)}

							<View style={styles.topBar}>															
								<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}></Text>																						
								</View>	
								<TouchableOpacity style={{height: 40, width: 40, justifyContent: "center", alignItems: "center"}}
										onPress={() => { this.props.navigation.goBack(null) }} >
										<Ionicons name={icoName} size={24} color={'black'} />
								</TouchableOpacity>		
							</View>

						</View>

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
	                        {that.renderDetails(this.state.width)}
						</View>

						<View style={styles.topBar}>	
							<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}></Text>																						
							</View>	
							<TouchableOpacity style={{height: 40, width: 40, justifyContent: "center", alignItems: "center"}}
									onPress={() => { this.props.navigation.goBack(null) }} >
									<Ionicons name={icoName} size={24} color={'black'} />
							</TouchableOpacity>													
						</View>
						
					</View>
				)}
				
			</View>

		)}
		</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});